import { env } from '@repo/environment';
export const getAuthWorkerUrl = (route)=>{
    const authWorkerUrl = new URL(route, env.PUBLIC_AUTH_API_BASE_URL).toString();
    return authWorkerUrl;
};
